export default "__VITE_ASSET__CI7JGBLL__"